"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _loginConnector = _interopRequireDefault(require("../../../../../login/login-connector"));
var _occasion = _interopRequireDefault(require("occasion"));
var _row = _interopRequireDefault(require("../../../../core/row"));
var _col = _interopRequireDefault(require("../../../../core/col"));
var _table = _interopRequireDefault(require("../../../../core/table"));
var _button = _interopRequireDefault(require("../../../../core/button"));
var _helpButton = _interopRequireDefault(require("../../../../core/help-button"));
var _alert = _interopRequireDefault(require("../../../../core/alert"));
var _racesHelp = _interopRequireDefault(require("./races-help"));
var _racesTable = _interopRequireDefault(require("./races-table"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _ref = /*#__PURE__*/_react.default.createElement(_alert.default, null, /*#__PURE__*/_react.default.createElement("p", {
  className: "lead"
}, " This competition does not have any races yet."), /*#__PURE__*/_react.default.createElement("p", null, "Check the parameters on the Divisions Tab and then generate the default races using the button below."));
var _ref2 = /*#__PURE__*/_react.default.createElement("h2", {
  className: "pull-xs-right"
}, "Races");
var _ref3 = /*#__PURE__*/_react.default.createElement(_helpButton.default, null, /*#__PURE__*/_react.default.createElement(_racesHelp.default, null));
const SetUpRaces = (0, _loginConnector.default)(class extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "_onCreateCompetitionRaces", () => {
      this.props.onCreateCompetitionRaces(this.props.competition.id);
    });
    _defineProperty(this, "_onDeleteCompetitionRaces", () => {
      this.props.onDeleteCompetitionRaces(this.props.competition.id);
    });
    _defineProperty(this, "_showDeleteRacesButton", () => {
      return this.props.competition.userCanModifyCompetitionStructure && this.props.competition.competitionDays.some(d => {
        return d.races.some(r => !r.hasEntries);
      });
    });
  }
  render() {
    const comp = this.props.competition;
    return /*#__PURE__*/_react.default.createElement("div", null, !comp.isAdministratedByUser ? null : !comp.hasRaces ? /*#__PURE__*/_react.default.createElement("div", null, _ref, /*#__PURE__*/_react.default.createElement(_button.default, {
      "data-test-id": "create-races",
      type: "primary",
      onClick: this._onCreateCompetitionRaces,
      block: true
    }, "Create Races")) : /*#__PURE__*/_react.default.createElement("div", null, _ref2, _ref3, !this._showDeleteRacesButton() ? null : /*#__PURE__*/_react.default.createElement(_button.default, {
      "data-test-id": "delete-races",
      onClick: this._onDeleteCompetitionRaces
    }, "Delete Races"), !comp.userCanModifyCompetitionStructure ? null : /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._onCreateCompetitionRaces
    }, "Add Any Missing Races and Eligibilities"), this.props.competition.competitionDays.map(day => /*#__PURE__*/_react.default.createElement("div", {
      key: day.id
    }, !day.races.length ? null : /*#__PURE__*/_react.default.createElement("div", {
      className: "card"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "card-header"
    }, /*#__PURE__*/_react.default.createElement("h2", null, (0, _occasion.default)(day.dayDate, 'dddd'))), /*#__PURE__*/_react.default.createElement("div", {
      className: "card-block"
    }, /*#__PURE__*/_react.default.createElement(_racesTable.default, {
      userIsSystemAdmin: this.props.userIsSystemAdmin,
      userCanModifyCompetitionStructure: comp.userCanModifyCompetitionStructure,
      competitionID: comp.id,
      races: day.races
    })))))));
  }
});

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _ref4 = {
  id: true,
  isAdministratedByUser: true,
  hasRaces: true,
  userCanModifyCompetitionStructure: true,
  competitionDays: {
    id: true,
    dayDate: true,
    races: {
      id: true,
      raceName: true,
      isCancelled: true,
      raceEntryLimit: true,
      raceReservedEntry: true,
      competitionDayID: true,
      isFull: true,
      eventDescription: true,
      hasEntries: true,
      numberOfCompletedEntries: true,
      numberOnWaitingList: true,
      specialRefs: true,
      eligibilities: {
        id: true,
        entryType: {
          description: true
        },
        classDivision: {
          rankingDivisionRef: true,
          rankingDivisionDescription: true,
          classDescription: true
        }
      }
    }
  }
};
var _default = exports.default = (0, _reactBicycle.connect)(SetUpRaces, props => ({
  userIsSystemAdmin: true,
  ["competition(competitionSlug:" + JSON.stringify(props.match.params.competitionSlug) + ",yearID:" + JSON.stringify(+props.match.params.yearID) + ")"]: _ref4
}), (client, props) => ({
  onCreateCompetitionRaces(competitionID) {
    return client.update('Race.create', {
      competitionID
    });
  },
  onDeleteCompetitionRaces(competitionID) {
    return client.update('Race.deleteAllCompetitionRaces', {
      competitionID
    });
  }
}));